import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Tenant } from '../../../model/tenant';
import { TenantsService } from '../../../services/tenants.service';
import { translate, TranslocoService } from '@ngneat/transloco';
import { LoggedUser } from '../../../common/logged-user.service';
import { AuthGuard } from '../../../common/auth-guard.service';

@Component({
  selector: 'app-tenant-details',
  templateUrl: './tenant-details.component.html',
  styleUrls: ['./tenant-details.component.scss']
})
export class TenantDetailsComponent implements OnInit {

  public tenant: Tenant;

  public items: MenuItem[];
  public activeItem: MenuItem;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private translocoService: TranslocoService,
              private authGuard: AuthGuard,
              private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadTenant(params.uuid));

    this.translocoService.selectTranslate('common.new').subscribe(() => {
      this.items = [
        {id: 'overview', label: translate('common.overview'), icon: 'pi pi-home'},
        {id: 'organizations', label: translate('model.organizations'), icon: 'pi pi-users'},
        {id: 'decoders', label: translate('model.decoders'), icon: 'pi pi-key'},
        {id: 'assetRepresentations', label: translate('model.assetRepresentations'), icon: 'pi pi-th-large'},
        {id: 'deviceCategories', label: translate('model.deviceCategories'), icon: 'pi pi-tags'},
        {id: 'triggerRules', label: translate('model.triggerRules'), icon: 'pi pi-list'},
        {id: 'measureTypes', label: translate('model.sensorTypes'), icon: 'pi pi-tag'},
        {id: 'propertyTypes', label: translate('model.propertyTypes'), icon: 'pi pi-tag'},
      ];
      if (!this.activeItem) {
        this.activeItem = this.items[0];
      }
      if (this.authGuard.adminRequired()) {
        this.items.splice(1, 0, {id: 'api', label: translate('common.api'), icon: 'pi pi-cloud'});
      }
    });
  }

  loadTenant(tenantUuid: string): void {
    this.tenantsService.getTenant(tenantUuid).subscribe(response => {
      this.tenant = response.tenant;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
  }

}
